const MILES_PER_KM = 0.621371;

export const kmToMiles = (km: number): number => km * MILES_PER_KM;
